import { apiClientV1 } from './apiClient';

export default {
  createHostVideo: (data) => apiClientV1.post('/video', { ...data }),
  getVideoById: (id) => apiClientV1.get(`/video/${id}/video-file`),
  deleteVideo: (videoId) => apiClientV1.put(`/video/${videoId}/delete`),

  logGenericLinkVideoWatch: (shortId) => apiClientV1.post(`/video/generic-links/${shortId}/watch`),
  getEditableClips: (videoId) => apiClientV1.get(`/video/${videoId}/editable-clips`),
  convertClipsForPreview: (videoId) => apiClientV1.put(`/video/${videoId}/clips-for-preview`),

  updateVideoAttributes: (videoId, data) => apiClientV1.patch(`/video/${videoId}/edit-attributes`, { ...data }),
  generateCoverPhoto: (videoId) => apiClientV1.post(`/video/${videoId}/cover-photo`),
  bulkUpdateVideosType: (data) => apiClientV1.put('/video/update-types', { ...data }),
  requestVideoTranscribe: (videoId) => apiClientV1.post(`/video/${videoId}/accessibility`),
  getVideoAccessibility: (videoId) => apiClientV1.get(`/video/${videoId}/accessibility`),

  createVideoClipRecord: (data) => apiClientV1.post('/video/createClip', { ...data }),
  createVideoSegment: (videoId, data) => apiClientV1.post(`/video/${videoId}/segments`, { ...data }),
  updateVideoSegments: (videoId, data) => apiClientV1.put(`/video/${videoId}/segments`, { ...data }),
  getCustomSegments: (params) => apiClientV1.get('/video/custom-segments', { params }),
  finalizeVideoPublish: (videoId, data) => apiClientV1.post(`/video/${videoId}/finalize-publishing`, { ...data }),
  cutClip: (clipId, data) => apiClientV1.put(`/video/clips/${clipId}/cut`, { ...data }, { silentErrorNotification: true }),
  trimClip: (clipId, data) => apiClientV1.put(`/video/clips/${clipId}/trim`, { ...data }, { silentErrorNotification: true }),
  saveVideoEditingHistory: (videoId, data) => apiClientV1.post(`/video/${videoId}/editing-history`, { ...data }),
  generateTimelineImages: (clipId, params) => apiClientV1.put(`/video/clips/${clipId}/timeline-images`, { ...params }),
  saveUnpublishedClips: (data) => apiClientV1.post('/video/clips/unpublished', { ...data }),
  deleteClips: (params) => apiClientV1.put('/video/delete-saved-clips', { ...params }),
  saveVideoDraft: (data) => apiClientV1.post('/video/unpublished', { ...data }),
  generateVideoPreview: (videoId, params) => apiClientV1.put(`/video/${videoId}/preview`, { ...params }),
  getVideoStatistic: (videoId) => apiClientV1.get(`/video/${videoId}/statistic`),
  getVideoAppearsInfo: (videoId) => apiClientV1.get(`/video/${videoId}/appears-info`),
  generateAiTranslations: (params) => apiClientV1.post('/video/translation', { ...params }),
  generateAudioDescription: (params) => apiClientV1.post('/video/audio-description', { ...params }),
  updateFloorplanVideoLock: (videoId, params) => apiClientV1.patch(`/video/${videoId}/floorplan-rep`, { ...params })
};
